export default __webpack_public_path__ + "static/media/cps.29cb3949.png";